import React from 'react';
import { connect } from 'react-redux';
import styles from './WorkComp.module.css';
import { DBTextField, DBDropDown, DBDateField, DBDropDownPDC, DBDropDownPDCWeight } from '_components';
import { PatientCareCenterNoteSection } from 'PatientCareCenter/Note';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';

class PatientCareCenterNoteWpSubjectiveWorkComp extends React.Component {

    computePdc(lift, liftFreq) {
        let key = Object.keys(this.props.pdcLookup)
            .find(x =>
                this.props.pdcLookup[x].WFXDWNO === lift
                && this.props.pdcLookup[x].WFXDWFNO === liftFreq
            );

        return key ? this.props.pdcLookup[key].WFXWPNO : undefined;
    }

    handleJobReqChange(event) {
        let jrLift = this.props.dolJobReqLift;
        let jrLiftFreq = this.props.dolJobReqLiftFreq;

        let tempColumn = undefined;
        let tempValue = undefined;

        switch (event.target.name) {
            case this.props.prefix + 'SUBWCDOLJOBREQLIFT':
                jrLift = parseInt(event.target.value);
                tempColumn = this.props.prefix + 'SUBWCDOLJOBREQLIFT';
                tempValue = jrLift;
                break;
            case this.props.prefix + 'SUBWCDOLJOBREQLIFTFREQ':
                jrLiftFreq = parseInt(event.target.value);
                tempColumn = this.props.prefix + 'SUBWCDOLJOBREQLIFTFREQ';
                tempValue = jrLiftFreq;
                break;
            default:
                break;
        }

        let pdc = this.computePdc(jrLift, jrLiftFreq);

        if (this.props.jobReqPdc !== undefined && pdc !== undefined && this.props.jobReqPdc.WPNO !== pdc) {
            this.props.updateIntField(this.props.noteId, this.props.table, this.props.prefix + 'NO', this.props.pk, this.props.prefix + 'SUBWCJOBREQPDC', pdc)
        } else if (this.props.jobReqPdc !== undefined && pdc === undefined) {
            this.props.clearField(this.props.noteId, this.props.table, this.props.prefix + 'NO', this.props.pk, this.props.prefix + 'SUBWCJOBREQPDC')
        } else if (this.props.jobReqPdc === undefined && pdc !== undefined) {
            this.props.updateIntField(this.props.noteId, this.props.table, this.props.prefix + 'NO', this.props.pk, this.props.prefix + 'SUBWCJOBREQPDC', pdc)
        }
    }


    handleCurrentChange(event) {
        let curLift = this.props.dolCurrentLift;
        let curLiftFreq = this.props.dolCurrentLiftFreq;

        switch (event.target.name) {
            case this.props.prefix + 'SUBWCDOLCURRENTLIFT':
                curLift = parseInt(event.target.value);
                break;
            case this.props.prefix + 'SUBWCDOLCURRENTLIFTFREQ':
                this.props.clearField(this.props.noteId, this.props.table, this.props.prefix + 'NO', this.props.pk, this.props.prefix + 'SUBWCDOLCURRENTLIFT')
                curLiftFreq = parseInt(event.target.value);
                break;
            default:
                break;
        }


        let pdc = this.computePdc(curLift, curLiftFreq);

        if (this.props.currentPdc !== undefined && pdc !== undefined && this.props.currentPdc.WPNO !== pdc) {
            this.props.updateIntField(this.props.noteId, this.props.table, this.props.prefix + 'NO', this.props.pk, this.props.prefix + 'SUBWCCURRENTPDC', pdc)
        } else if (this.props.currentPdc !== undefined && pdc === undefined) {
            this.props.clearField(this.props.noteId, this.props.table, this.props.prefix + 'NO', this.props.pk, this.props.prefix + 'SUBWCCURRENTPDC')
        } else if (this.props.currentPdc === undefined && pdc !== undefined) {
            this.props.updateIntField(this.props.noteId, this.props.table, this.props.prefix + 'NO', this.props.pk, this.props.prefix + 'SUBWCCURRENTPDC', pdc)
        }
    }
    render() {
        return (
            <PatientCareCenterNoteSection id='subj_workComp' name='Work Comp' level={5}>
                {this.props.noteType === 1 && (<><div className={styles.row}>
                    <label className={styles.narrow_col}>Referral Source:</label>
                    <div className={styles.leftover_col}>
                        <DBTextField
                            className={styles.drop_down}
                            noteId={this.props.noteId}
                            entity={this.props.table}
                            entityKeyColumn={this.props.prefix + 'NO'}
                            entityKeyValue={this.props.pk}
                            field={this.props.prefix + 'SUBWCREFSOURCE'}
                        />
                    </div>
                </div>


                    <div className={styles.row}>
                        <label className={styles.narrow_col}>Ins. Adjuster/NCM:</label>
                        <div className={styles.leftover_col}>
                            <DBTextField
                                className={styles.drop_down}
                                noteId={this.props.noteId}
                                entity={this.props.table}
                                entityKeyColumn={this.props.prefix + 'NO'}
                                entityKeyValue={this.props.pk}
                                field={this.props.prefix + 'SUBWCINSADJUSTER'}
                            />
                        </div>
                    </div></>)
                }
                <div className={styles.row}>
                    <label className={styles.narrow_col}>Employer:</label>
                    <span className={styles.leftover_col}>{this.props.employer}</span>
                </div>
                <div className={styles.row} id='subj_wc_occupation'>
                    <label className={styles.narrow_col_req}>Occupation:</label>
                    <span className={styles.leftover_col}>
                        {this.props.occupations !== undefined &&
                            <DBDropDown
                                className={styles.drop_down}
                                noteId={this.props.noteId}
                                entity={this.props.table}
                                entityKeyColumn={this.props.prefix + 'NO'}
                                entityKeyValue={this.props.pk}
                                field={this.props.prefix + 'SUBWCOCCUPATION'}
                                customOptions={this.props.occupations}
                            />
                        }
                        {this.props.occupations === undefined &&
                            <DBTextField
                                className={styles.drop_down}
                                noteId={this.props.noteId}
                                entity={this.props.table}
                                entityKeyColumn={this.props.prefix + 'NO'}
                                entityKeyValue={this.props.pk}
                                field={this.props.prefix + 'SUBWCOCCUPATION'}
                            />
                        }
                    </span>
                </div>
                <div className={styles.row} id='subj_wc_status'>
                    <label className={styles.narrow_col_req}>Status:</label>
                    <span className={styles.leftover_col}>
                        <DBDropDown
                            className={styles.drop_down}
                            noteId={this.props.noteId}
                            entity={this.props.table}
                            entityKeyColumn={this.props.prefix + 'NO'}
                            entityKeyValue={this.props.pk}
                            field={this.props.prefix + 'SUBWCSTATUS'}
                            masterEntity='PTMASTERWCSTATUS'
                            masterEntityKeyColumn='WSNO'
                            masterEntitySort='WSORDER'
                            masterEntityDisplay='WSNAME'
                        />
                    </span>
                </div>
                <div className={styles.row}>
                    <label className={styles.narrow_col}>Last Day:</label>
                    <span className={styles.leftover_col}>
                        <DBDateField
                            noteId={this.props.noteId}
                            entity={this.props.table}
                            entityKeyColumn={this.props.prefix + 'NO'}
                            entityKeyValue={this.props.pk}
                            maxDate={new Date()}
                            field={this.props.prefix + 'SUBWCLASTDAY'}
                        />
                    </span>
                </div>
                {this.props.noteType !== 1 && <PatientCareCenterNoteSection id='subj_wc_current_pdc' name='Current PDC Analysis' level={2} allowCollapse={false} >
                    <div className={styles.row}>
                        <label className={styles.wide_col}>How much time is the patient currently able to <b>stand</b>:</label>
                        <span className={styles.leftover_col}>
                            <DBDropDownPDC
                                className={styles.drop_down}
                                noteId={this.props.noteId}
                                entity={this.props.table}
                                entityKeyColumn={this.props.prefix + 'NO'}
                                entityKeyValue={this.props.pk}
                                field={this.props.prefix + 'SUBWCCURRENTSTAND'}
                                isCurrent={true}
                            />
                        </span>
                    </div>
                    <div className={styles.row}>
                        <label className={styles.wide_col}>How much time is the patient currently able to <b>walk</b>:</label>
                        <span className={styles.leftover_col}>
                            <DBDropDownPDC
                                className={styles.drop_down}
                                noteId={this.props.noteId}
                                entity={this.props.table}
                                entityKeyColumn={this.props.prefix + 'NO'}
                                entityKeyValue={this.props.pk}
                                field={this.props.prefix + 'SUBWCCURRENTWALK'}
                                isCurrent={true}
                            />
                        </span>
                    </div>
                    <div className={styles.row}>
                        <label className={this.props.noteType === 2 ? styles.wide_col : styles.wide_col_req}>Current <b>lift</b> frequency:</label>
                        <span className={styles.leftover_col}>
                            <DBDropDown
                                className={styles.drop_down}
                                noteId={this.props.noteId}
                                entity={this.props.table}
                                entityKeyColumn={this.props.prefix + 'NO'}
                                entityKeyValue={this.props.pk}
                                field={this.props.prefix + 'SUBWCDOLCURRENTLIFTFREQ'}
                                masterEntity='PTMASTERWCDOLPDCWEIGHTFREQ'
                                masterEntityKeyColumn='DWFNO'
                                masterEntitySort='DWFORDER'
                                masterEntityDisplay='DWFNAME'
                                onChange={event => this.handleCurrentChange(event)}
                            />
                        </span>
                    </div>
                    <div className={styles.row}>
                        <label className={this.props.noteType === 2 ? styles.wide_col : styles.wide_col_req}>How much weight is the patient currently able to <b>lift</b>:</label>
                        <span className={styles.leftover_col}>
                            <DBDropDownPDCWeight
                                className={styles.drop_down}
                                noteId={this.props.noteId}
                                entity={this.props.table}
                                entityKeyColumn={this.props.prefix + 'NO'}
                                entityKeyValue={this.props.pk}
                                field={this.props.prefix + 'SUBWCDOLCURRENTLIFT'}
                                masterField={this.props.prefix + 'SUBWCDOLCURRENTLIFTFREQ'}
                                onChange={event => this.handleCurrentChange(event)}
                            />
                        </span>
                    </div>
                    <div className={styles.row}>
                        <label className={styles.wide_col}>Current PDC:</label>
                        <span className={styles.leftover_col}>
                            {this.props.currentPdc ? this.props.currentPdc.WPNAME : ''}
                        </span>
                    </div>
                </PatientCareCenterNoteSection>}


                <PatientCareCenterNoteSection id='subj_wc_job_pdc' name='Job Required PDC Analysis' level={5} allowCollapse={false}>
                    <div className={styles.row}>
                        <label className={styles.wide_col}>How much time is the patient required to <b>stand</b>:</label>
                        <span className={styles.leftover_col}>
                            <DBDropDownPDC
                                className={styles.drop_down}
                                noteId={this.props.noteId}
                                entity={this.props.table}
                                entityKeyColumn={this.props.prefix + 'NO'}
                                entityKeyValue={this.props.pk}
                                field={this.props.prefix + 'SUBWCJOBREQSTAND'}
                                isCurrent={true}
                            />
                        </span>
                    </div>
                    <div className={styles.row}>
                        <label className={styles.wide_col}>How much time is the patient required to <b>walk</b>:</label>
                        <span className={styles.leftover_col}>
                            <DBDropDownPDC
                                className={styles.drop_down}
                                noteId={this.props.noteId}
                                entity={this.props.table}
                                entityKeyColumn={this.props.prefix + 'NO'}
                                entityKeyValue={this.props.pk}
                                field={this.props.prefix + 'SUBWCJOBREQWALK'}
                                isCurrent={true}
                            />
                        </span>
                    </div>
                    <div className={styles.row}>
                        <label className={this.props.noteType === 4 ? styles.wide_col : styles.wide_col_req}>Job required <b>lift</b> frequency:</label>
                        <span className={styles.leftover_col}>
                            <DBDropDown
                                className={styles.drop_down}
                                noteId={this.props.noteId}
                                entity={this.props.table}
                                entityKeyColumn={this.props.prefix + 'NO'}
                                entityKeyValue={this.props.pk}
                                field={this.props.prefix + 'SUBWCDOLJOBREQLIFTFREQ'}
                                masterEntity='PTMASTERWCDOLPDCWEIGHTFREQ'
                                masterEntityKeyColumn='DWFNO'
                                masterEntitySort='DWFORDER'
                                masterEntityDisplay='DWFNAME'
                                onChange={event => this.handleJobReqChange(event)}
                            />
                        </span>
                    </div>                    <div className={styles.row}>
                        <label className={this.props.noteType === 4 ? styles.wide_col : styles.wide_col_req}>How much weight is the patient required to <b>lift</b>:</label>
                        <span className={styles.leftover_col}>
                            <DBDropDownPDCWeight
                                className={styles.drop_down}
                                noteId={this.props.noteId}
                                entity={this.props.table}
                                entityKeyColumn={this.props.prefix + 'NO'}
                                entityKeyValue={this.props.pk}
                                field={this.props.prefix + 'SUBWCDOLJOBREQLIFT'}
                                masterField={this.props.prefix + 'SUBWCDOLJOBREQLIFTFREQ'}
                                onChange={event => this.handleJobReqChange(event)}
                            />
                        </span>
                    </div>
                    <div className={styles.row}>
                        <label className={styles.wide_col}>Job Required PDC:</label>
                        <span className={styles.leftover_col}>
                            {this.props.jobReqPdc ? this.props.jobReqPdc?.WPNAME : ''}
                        </span>
                    </div>
                </PatientCareCenterNoteSection>

                <PatientCareCenterNoteSection id='subj_wc_goal_pdc' name='Goal PDC' level={5} allowCollapse={false}>
                    <div className={styles.row}>
                        <label className={styles.wide_col_req}>{this.props.noteType === 1 ? 'PDC Level:' : 'Level:'}</label>
                        <span className={styles.leftover_col}>
                            <DBDropDown
                                className={styles.drop_down}
                                noteId={this.props.noteId}
                                entity={this.props.table}
                                entityKeyColumn={this.props.prefix + 'NO'}
                                entityKeyValue={this.props.pk}
                                field={this.props.prefix + 'SUBWCGOALPDC'}
                                masterEntity='PTMASTERWCPDC'
                                masterEntityKeyColumn='WPNO'
                                masterEntitySort='WPORDER'
                                masterEntityDisplay='WPNAME'
                            />
                        </span>
                    </div>
                </PatientCareCenterNoteSection>

            </PatientCareCenterNoteSection>
        );
    }

}

function mapDispatchToProps(dispatch) {
    return {
        updateIntField: bindActionCreators(noteActions.updateIntField, dispatch),
        clearField: bindActionCreators(noteActions.clearField, dispatch),
        clearGoals: bindActionCreators(noteActions.clearGoals, dispatch)
    };
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let epno = noteType !== 1 ? state.entities.notes.PTNOTE[pk].NTEPNO : state.entities.notes.PTEVAL[pk].EVEPNO;

    let employer = Object.keys(state.entities.insured)
        .filter(key => {
            return (state.entities.insured[key].epno === epno
                && state.entities.insured[key].position === 1)
        })
        .map(key => state.entities.insured[key]);
    let occupations = undefined;

    if (state.entities.admissions[epno].isMdcps === true) {
        occupations = Object.keys(state.entities.masterData.FNJOBTITLES)
            .filter(key => {
                return (state.entities.masterData.FNJOBTITLES[key].JTMDCPS === true);
            })
            .sort((a, b) => {
                return state.entities.masterData.FNJOBTITLES[a].JTNAME > state.entities.masterData.FNJOBTITLES[b].JTNAME ? 1 : -1;
            })
            .map(key => { return { id: state.entities.masterData.FNJOBTITLES[key].JTNAME, value: state.entities.masterData.FNJOBTITLES[key].JTNAME } })
    }

    let prefix = noteType === 1 ? 'EV' : 'NT';
    let table = noteType === 1 ? 'PTEVAL' : 'PTNOTE';

    let dolJobReqLift = noteType === 1 ?
        state.entities.notes.PTEVAL[pk].EVSUBWCDOLJOBREQLIFT :
        state.entities.notes.PTNOTE[pk].NTSUBWCDOLJOBREQLIFT;
    let dolJobReqLiftFreq = noteType === 1 ?
        state.entities.notes.PTEVAL[pk].EVSUBWCDOLJOBREQLIFTFREQ :
        state.entities.notes.PTNOTE[pk].NTSUBWCDOLJOBREQLIFTFREQ;

    let dolCurrentLift = noteType === 1 ?
        state.entities.notes.PTEVAL[pk].EVSUBWCDOLCURRENTLIFT :
        state.entities.notes.PTNOTE[pk].NTSUBWCDOLCURRENTLIFT;
    let dolCurrentLiftFreq = noteType === 1 ?
        state.entities.notes.PTEVAL[pk].EVSUBWCDOLCURRENTLIFTFREQ :
        state.entities.notes.PTNOTE[pk].NTSUBWCDOLCURRENTLIFTFREQ;


    let jrPDC = noteType === 1 ?
        state.entities.notes.PTEVAL[pk].EVSUBWCJOBREQPDC :
        state.entities.notes.PTNOTE[pk].NTSUBWCJOBREQPDC;
    let curPDC = noteType === 1 ?
        state.entities.notes.PTEVAL[pk].EVSUBWCCURRENTPDC :
        state.entities.notes.PTNOTE[pk].NTSUBWCCURRENTPDC;

    return {
        noteId: noteId,
        noteType,
        pk,
        prefix,
        table,
        employer: employer && employer[0] ? employer[0].employerName : undefined,
        occupations: occupations,
        dolJobReqLift,
        dolJobReqLiftFreq,
        dolCurrentLift,
        dolCurrentLiftFreq,
        pdcLookup: state.entities.masterData.PTMASTERWCDOLPDCWEIGHTFREQXREF,
        jobReqPdc: state.entities.masterData.PTMASTERWCPDC[jrPDC],
        currentPdc: state.entities.masterData.PTMASTERWCPDC[curPDC],
    };
}

const connectedPatientCareCenterNoteWpSubjectiveWorkComp = connect(mapStateToProps, mapDispatchToProps)(PatientCareCenterNoteWpSubjectiveWorkComp);
export { connectedPatientCareCenterNoteWpSubjectiveWorkComp as PatientCareCenterNoteWpSubjectiveWorkComp };

